import { useQuery } from '@tanstack/react-query';
import { match } from 'ts-pattern';

import { clientCountOptions } from '@/entities/client';
import {
    SheetBody,
    SheetDescription,
    SheetHeader,
    SheetPanel,
    SheetTitle,
} from '@/shared/ui/panels/sheet-panel';

import { ClientTable } from './client-list/client-table';

export function ClientList() {
    const total = useQuery(clientCountOptions());

    return (
        <SheetPanel type="clients/list" size="large">
            <SheetHeader>
                <SheetTitle>Clients</SheetTitle>
                <SheetDescription>
                    {match(total)
                        .with({ isPending: true }, () => 'loading...')
                        .with({ data: { count: 1 } }, () => '1 client')
                        .otherwise(() => `${total.data?.count ?? 0} clients`)}
                </SheetDescription>
                <SheetDescription className="sr-only">
                    A table with information about all your clients, including name, date of last
                    session, and percentage of profile completeness.
                </SheetDescription>
            </SheetHeader>
            <SheetBody>
                <ClientTable />
            </SheetBody>
        </SheetPanel>
    );
}
